import { ChatAdapterOptions } from '../types/adapterOptions';
import { LangGraphHeaders } from '../types/langGraph';

export const getHeadersToUse = <AnyAiMsg>(
  adapterOptions: ChatAdapterOptions<AnyAiMsg>
): LangGraphHeaders => {
  return adapterOptions.headers || {};
};
